export default {"src":"/_next/static/media/b3.874d75da.svg","height":65,"width":159,"blurWidth":0,"blurHeight":0};